<template>
  <v-card flat>
    <v-card-title primary-title>
      <h3 class="display-1 mb-3">Weitere Informationen</h3>
      <h5 class="subheading mb-0">Weitergehende Informationen zu Ihrem Betrieb, Links zu Ihren Profilen etc. Diese Daten dienen zur Anzeige auf Ihrem öffentlichen Profil, und auch hier gilt, wenn Sie etwas nicht angeben wollen, lassen Sie das Feld bitte einfach leer.</h5>
    </v-card-title>
    <v-card-text>
      <div v-if="betrieb.name">
        <!-- <form v-on:submit="saveForm()"> -->
        <form>
          <v-layout row>
            <v-flex xs4>
              <v-subheader>Kurztext
                <br>Dieser Text wird zum Teil auf der Startseite angezeigt
              </v-subheader>
            </v-flex>
            <v-flex xs8 lg8>
              <v-textarea
                name="input-1"
                label="Kurztext"
                v-model="betrieb.kurztext"
                :rules="[(v) => v.length <= 150 || 'Bitte maximal 150 Zeichen verwenden']"
                :counter="150"
                hint="Dieser Text taucht auf der Startseite auf"
              ></v-textarea>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs4>
              <v-subheader>Beschreibung
                <br>Dieser Text wird auf Ihrem Profil angezeigt.
              </v-subheader>
            </v-flex>
            <v-flex xs8 lg8>
              <v-textarea name="input-1" label="Beschreibung" v-model="betrieb.beschreibung"></v-textarea>
            </v-flex>
          </v-layout>

<v-layout row>
            <v-flex xs4>
              <v-subheader>Facebook Profil 
                <br>Link zu Ihrem Facebook Profil.
              </v-subheader>
            </v-flex>
            <v-flex xs8 lg8>
              <v-text-field name="input-1" label="Link zu Ihrer Facebook Seite" v-model="betrieb.facebook"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs4>
              <v-subheader>Instagram Profil
                <br>Link zu Ihrem Instagram Profil.
              </v-subheader>
            </v-flex>
            <v-flex xs8 lg8>
              <v-text-field name="input-1" label="Link zu Ihrem Instagram Profil" v-model="betrieb.instagram"></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs4>
              <v-subheader>Whatsapp Kontakt
                <br>
                z.B.
              </v-subheader>

              <span class="caption green--text ml-3">richtig: 4917812345678</span><br>
                <span class="caption  red--text ml-3">falsch: +0049-(178)12345678</span>
            </v-flex>
            <v-flex xs8 lg8>
              <v-text-field name="input-1" type="number" label="WhatsApp Kontakt Nummer" v-model="betrieb.whatsapp"></v-text-field>
            </v-flex>
          </v-layout>


          <v-layout row>
            <v-flex xs4>
              <v-subheader>Öffnungszeiten</v-subheader>
            </v-flex>
            <v-flex xs3 lg3>
              <v-text-field
                name="input-1"
                label="Montag"
                type="time"
                hint="Öffnungszeit"
                v-model="betrieb.offen_montag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Dienstag"
                type="time"
                hint="Öffnungszeit"
                v-model="betrieb.offen_dienstag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Mittwoch"
                type="time"
                hint="Öffnungszeit"
                v-model="betrieb.offen_mittwoch"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Donnerstag"
                type="time"
                hint="Öffnungszeit"
                v-model="betrieb.offen_donnerstag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Freitag"
                type="time"
                hint="Öffnungszeit"
                v-model="betrieb.offen_freitag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Samstag"
                type="time"
                hint="Öffnungszeit"
                v-model="betrieb.offen_samstag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Sonntag"
                type="time"
                hint="Öffnungszeit"
                v-model="betrieb.offen_sonntag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Mittagspause von"
                type="time"
                hint="Anfang der Mittagspause"
                v-model="betrieb.mittag_von"
              ></v-text-field>
            </v-flex>

            <v-flex xs3 lg3 offset-xs1>
              <v-text-field
                name="input-1"
                label="Montag"
                type="time"
                hint="Schließzeit"
                v-model="betrieb.zu_montag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Dienstag"
                type="time"
                hint="Schließzeit"
                v-model="betrieb.zu_dienstag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Mittwoch"
                type="time"
                hint="Schließzeit"
                v-model="betrieb.zu_mittwoch"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Donnerstag"
                type="time"
                hint="Schließzeit"
                v-model="betrieb.zu_donnerstag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Freitag"
                type="time"
                hint="Schließzeit"
                v-model="betrieb.zu_freitag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Samstag"
                type="time"
                hint="Schließzeit"
                v-model="betrieb.zu_samstag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Sonntag"
                type="time"
                hint="Schließzeit"
                v-model="betrieb.zu_sonntag"
              ></v-text-field>
              <v-text-field
                name="input-1"
                label="Mittagspause bis"
                type="time"
                hint="Ende Mittagspause"
                v-model="betrieb.mittag_bis"
              ></v-text-field>

            </v-flex>
          </v-layout>
        </form>


 <v-layout row class="mt-3">
       <v-flex xs4>
        &nbsp;
       </v-flex>
       <v-flex xs4 class="text-xs-center">
        <v-btn v-on:click.native="saveForm()" large color="accent">Speichern</v-btn>
       </v-flex>
       <v-flex xs4 class="text-xs-right">
          <v-btn @click="nexttab()" large>Weiter <v-icon right>chevron_right</v-icon></v-btn>
       </v-flex>
    </v-layout>

      </div>

      <div v-else>
        <v-alert
          outline
          color="info"
          icon="info"
          :value="true"
        >Aktuell ist noch kein Betrieb mit Ihrem Nutzer-Account verknüpft, Bitte melden Sie sich bei uns, damit wir Sie verifizieren können:
          <v-btn href="mailto:info@lokaleshandwerk.de">
            <v-icon left>mail</v-icon>info@lokaleshandwerk.de
          </v-btn>
        </v-alert>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
// import Form from 'vform'
// import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  props: {
    betrieb: ''
  },
  mounted () {
  },
  data: function () {
    return {
      companyId: '',
      company: {
        name: '',
        address: '',
        website: '',
        email: '',
        kurztext: ''
      }
    }
  },
  methods: {
    nexttab (event) {
      this.$emit('tabswitch')
    },
    saveForm () {
      var app = this
      var newCompany = app.betrieb

      axios.patch('/api/v1/companies/' + app.betrieb.id, newCompany)
                .then(resp => {
                  this.$store.dispatch('responseMessage', {
                    type: 'success',
                    text: this.$t('betrieb_updated')
                  })
                  app.$router.replace('/meinbetrieb')
                })
                .catch(resp => {
                  this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: this.$t('error_alert_text')
                  })
                })
    }
  }
}

// export default {
//   data: () => ({
//     form: new Form({
//       name: '',
//       email: ''
//     })
//   }),

//   computed: mapGetters({
//     user: 'authUser'
//   }),

//   created () {
//     // Fill the form with user data.
//     this.form.keys().forEach(key => {
//       this.form[key] = this.user[key]
//     })
//   },

//   methods: {
//     async update () {
//       if (await this.formHasErrors()) return

//       const { data } = await this.form.patch('/api/settings/profile')

//       await this.$store.dispatch('updateUser', { user: data })
//       this.$emit('busy', false)
//     }
//   },

//   watch: {
//     form () {
//       console.log(this.form)
//     }
//   }
// }
</script>
